import { io } from 'socket.io-client';

let socket;

export const getSocket = () => {
  if (!socket) {
    socket = io(window.APPCONFIG.BACKEND_URL || '/', {
      autoConnect: true,

      // 🔁 reconnection control
      reconnection: true,
      reconnectionAttempts: 5,        // stop after 5 tries
      // reconnectionDelay: 1000,        // start with 1s
      reconnectionDelayMax: 10000,    // max 10s delay
      randomizationFactor: 0.5,       // spread retries across users

      timeout: 10000,                 // connection timeout
    });

    socket.on('connect', () => {
      console.log('🟢 Socket connected');
    });

    socket.on('disconnect', (reason) => {
      console.log('🔴 Socket disconnected:', reason);
    });

    socket.on('reconnect_attempt', (attempt) => {
      console.log(`🔁 Reconnect attempt ${attempt}`);
    });

    socket.on('reconnect_failed', () => {
      console.log('❌ Reconnect failed permanently');
    });
  }

  return socket;
};
